import Layout from '../../internal/Layout.vue'
import OrderAutomationPage from './orderAutomation.vue'
import ManageOrderAutomationPage from './manageAutomation.vue'
import DetailAutomation from './detailAutomation.vue'

const OrderAutomationRoutes = {
  component: Layout,
  children: [
    {
      name: 'OrderAutomation',
      path: '/',
      component: OrderAutomationPage,
      meta: {
        module: 'ordem_de_servico',
        requiresAuth: true,
        requiresMaster: true,
      },
    },
    {
      name: 'ManageOrderAutomation',
      path: '/manageAutomation',
      component: ManageOrderAutomationPage,
      meta: {
        module: 'ordem_de_servico',
        requiresAuth: true,
        requiresMaster: true,
      },
    },
    {
      name: 'DetailAutomation',
      path: '/detailAutomation',
      component: DetailAutomation,
      meta: {
        module: 'ordem_de_servico',
        requiresAuth: true,
        requiresMaster: true,
      },
    },
  ],
}

export default OrderAutomationRoutes
